import $apiJSON from 'http/apiJSON'

const BASE = '/students/students'

export async function listStudents(params = {}) {
  return $apiJSON.get(`${BASE}/`, { params })
}

export async function getStudent(id) {
  return $apiJSON.get(`${BASE}/${id}/`)
}

export async function createStudent(payload) {
  return $apiJSON.post(`${BASE}/`, payload)
}

export async function enrollStudent(payload) {
  return $apiJSON.post(`${BASE}/enroll/`, payload)
}

export async function updateStudent(id, payload) {
  return $apiJSON.patch(`${BASE}/${id}/`, payload)
}

export async function transferGroup(id, payload) {
  return $apiJSON.post(`${BASE}/${id}/transfer-group/`, payload)
}

export async function changeStatus(id, payload) {
  return $apiJSON.post(`${BASE}/${id}/change-status/`, payload)
}

export async function getStudentCard(id) {
  return $apiJSON.get(`${BASE}/${id}/card/`)
}

export default {
  listStudents,
  getStudent,
  createStudent,
  enrollStudent,
  updateStudent,
  transferGroup,
  changeStatus,
  getStudentCard,
}
